import React, { useEffect, useState } from 'react';
import { create } from '../../services/upload-files.service';
import { useNavigate } from 'react-router';
import useFetch from '../../hooks/useFetch';
import { exportToExcel } from '../../services/fetch-data.service';
const EXPORT_SBTIREPORT_API = 'https://dev.sustainabilitypro.io/api/v1/export_sbti?company_id=1&year=2025'

const Sbti = () => {
    const [formState, setFormState] = useState({});


    const formFeilds = {
        "fields": [
            {
                "id": 1,
                "field_label": "General Information",
                "field_name": "heading",
                "is_required": false,
            },
            {
                "id": 1.1,
                "field_label": "VALIDATION REQUESTED",
                "field_name": "subheading",
                "is_required": false,
            },
            {
                "id": '1.1.1',
                "field_label": "Please select the target validation service option you are requesting",
                "field_name": "1.1.1",
                "field_description": "Please confirm that you are submitting under the full near-term target validation service. This service option includes two rounds of assessment and costs 9,500 USD + applicable VAT.Please specify whether this is your first or second assessment under the full target validation service. The second assessment is only available to companies who have paid for the full service, been rejected on their first assessment, and re-submit within 6 months. For the target update service, please fill in the Near- term Target Update Form.For further information on the benefits and costs of the target validation service, please refer to the FAQs.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '1.1.1.a',
                        "answer_label": "Target validation service",
                        "answer_description": " Target validation service",
                        "answer_type": "radio",
                        "answer_name": "answer_1.1.1.a",
                        "answer_options": [
                            { "key": "full service", "value": "Full Service" },
                        ]
                    },
                    {
                        "answer_id": '1.1.1.b',
                        "answer_label": "Please indicate if this is your first or second assessment",
                        "answer_description": "Please indicate if this is your first or second assessment ",
                        "answer_type": "radio",
                        "answer_name": "answer_'1.1.1.b'",
                        "answer_options": [
                            { "key": "first assessment", "value": "First assessment" },
                            { "key": "second assessment", "value": "Second assessment" },
                        ]
                    },
                ]
            },
            {
                "id": '1.1.2',
                "field_label": "Please indicate if you are requesting a fee exemption.",
                "field_name": "1.1.2",
                "field_description": "Please select yes if you are eligible for and wish to request a fee exemption. Companies eligible for an exemption are only those headquartered in   economies   in   transition   and   developing",
                "is_required": false,
                "answers": [

                    {
                        "answer_id": '1.1.2a',
                        "answer_label": "Please make sure you are eligible for an exemption.",
                        "answer_description": "Please select yes if you are eligible for and wish to request a fee exemption. Companies eligible for an exemption are only those headquartered in   economies   in   transition   and   developing",
                        "answer_type": "radio",
                        "answer_name": "answer_1.1.2a",
                        "answer_options": [
                            { "key": "yes", "value": "Yes" },
                            { "key": "no", "value": "No" }
                        ]
                    }
                ]
            },
            {
                "id": '1.1.3',
                "field_label": " Is your company a responder for the CDP Investor Climate Change Questionnaire for the year in which you have submitted your SBT?",
                "field_name": "1.1.3",
                "field_description": "If your company has responded or intends to respond to the CDP Investor Climate Change Questionnaire in the year in which your company has submitted targets to the SBTi, select ‘yes’. For example, your company has submitted targets to the SBTi for validation in 2022 and your company is disclosing to the CDP 2022 Investor Climate Change Questionnaire, you would select 'yes'. If your company has also responded to that questionnaire in the past, please attach the responses for your targets base year and the most recent  response together with your submission, if available. Whenever possible, the information provided in this form should be consistent with the relevant information in your CDP  Questionnaire Response. If there are any significant inconsistencies, please explain them in Section 5.1.2.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '1.1.3a',
                        "answer_label": "Select any one",
                        "answer_description": "Select any one",
                        "answer_type": "radio",
                        "answer_name": "answer_1.1.3a",
                        "answer_options": [
                            { "key": "yes", "value": "Yes" },
                            { "key": "no", "value": "No" }
                        ]
                    },
                ]
            },
            {
                "id": "1.1.4",
                "field_label": "Have you paid any of the SBTi partners (CDP, UN Global Compact, WRI, WWF) to receive technical advice to model your targets? If yes, state which partner(s) and describe the type",
                "field_name": "1.1.4",
                "field_description": "You should only consider payments made to any of the partners (CDP, UN Global Compact, WRI or WWF) in exchange of technical advice, support or guidance to develop science-based targets or evaluate targets against the SBTi criteria  other   than  payments  for  the  target",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '1.1.4a',
                        "answer_label": "Select any one",
                        "answer_description": "Select any one",
                        "answer_type": "radio",
                        "answer_name": "answer_1.1.4a",
                        "answer_options": [
                            { "key": "yes", "value": "Yes" },
                            { "key": "no", "value": "No" }
                        ]
                    },
                ]
            },
            {
                "id": '1.1.41',
                "field_label": "of support you received. Please also indicate if you have an ongoing partnership with any of the SBTi partners and whether this is a paid partnership.",
                "field_name": "1.1.41",
                "field_description": "If you selected 'Yes', please state which partner(s) you obtained the service from, and the nature/scope of the service. This information is requested to prevent conflicts of interest when assigning members of our technical team to review targets. A conflict of interest is triggered when a company provides any significant amount of funds to any of the SBTi partner organizations (e.g., through a partnership, service offering, donation). Any SBTi partner organization with a conflict of interest (COI) must be excluded from the assessment process.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '1.1.41a',
                        "answer_label": "any of the SBTi partners",
                        "answer_description": "any of the SBTi partners",
                        "answer_type": "radio",
                        "answer_name": "answer_1.1.41a",
                        "answer_options": [
                            { "key": "yes", "value": "Yes" },
                            { "key": "no", "value": "No" }
                        ]
                    },
                    {
                        "answer_id": '1.1.41b',
                        "answer_label": "Is this ongoing partnership(s) a paid partnership",
                        "answer_description": "Is this ongoing partnership(s) a paid partnership",
                        "answer_type": "radio",
                        "answer_name": "answer_1.1.41b",
                        "answer_options": [
                            { "key": "yes", "value": "Yes" },
                            { "key": "no", "value": "No" }
                        ]
                    },
                ]
            },
            {
                "id": '1.1.5',
                "field_label": "  Please indicate which scope 1 and 2 temperature alignment you are aiming for  ",
                "field_name": "1.1.5",
                "field_description": "Please select which temperature alignment your company is aiming for regarding your scope 1 and 2 target submission. This question is only relevant until July 14, 2022, when SBTi criteria V4.2 is still in effect and companies can choose to submit under V4.2 or V5.0.z",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '1.1.5a',
                        "answer_label": "Well-below 2\u00B0C 1.5\u00B0C",
                        "answer_description": "Well-below 2\u00B0C 1.5\u00B0C",
                        "answer_type": "textarea",
                        "answer_name": "answer_1.1.5a",
                        "answer_options": [

                        ]
                    },
                ]
            },
            {
                "id": '1.1.6',
                "field_label": "  Please indicate which version of the criteria you are submitting under ",
                "field_name": "1.1.6",
                "field_description": "SBTi criteria version 5.0 will be in effect as of July 15th, 2022. All submissions received by the SBTi prior to July 15th, 2022, can be assessed against criteria version 4.2 or 5.0.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '1.1.6a',
                        "answer_label": "SBTi criteria V4.2 SBTi criteria V5.0",
                        "answer_description": "SBTi criteria V4.2 SBTi criteria V5.0",
                        "answer_type": "textarea",
                        "answer_name": "answer_1.1.6a",
                        "answer_options": [

                        ]
                    },
                ]
            },
            {
                "id": 1.2,
                "field_label": "COMPANY INFORMATION",
                "field_name": "subheading",
                "is_required": false,
            },
            {
                "id": '1.2.1',
                "field_label": " Please indicate correct spelling, capitalization and punctuation to be used in public communications.  ",
                "field_name": "1.2.1",
                "field_description": "Company name as you want it to be publicly displayed on the SBTi and its partner's websites, as well as, in other communication materials. If you are using your company's legal designation, please make sure that the spelling, capitalization and punctuation of your company name is correct. If you are a CDP Responder and the name differs from how it appears in your CDP questionnaire response, please indicate how it differs.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '1.2.1a',
                        "answer_label": "Company name",
                        "answer_description": "Company name",
                        "answer_type": "textarea",
                        "answer_name": "answer_1.2.1a",
                        "answer_options": [

                        ]
                    },
                ]
            },
            {
                "id": '1.2.2',
                "field_label": " Please indicate the ISIN (if relevant, and available) to be used to identify the company in the public SBTi database. ",
                "field_name": "1.2.2",
                "field_description": "An International Securities Identification Number (ISIN) is a code that uniquely identifies a specific securities issue. ISIN codes have a total of 12 characters consisting of both letters and numbers.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '1.2.2a',
                        "answer_label": "Company ISIN",
                        "answer_description": "Company ISIN",
                        "answer_type": "textarea",
                        "answer_name": "answer_1.2.2a",
                        "answer_options": [

                        ]
                    },
                ]
            },
            {
                "id": '1.2.3',
                "field_label": " Please indicate the LEI (if relevant, and available) to be used to identify the company in the public SBTi database. ",
                "field_name": "1.2.3",
                "field_description": "The Legal Entity Identifier (LEI) is a unique global identifier for legal entities participating in financial transactions. Also known as an LEI code or LEI number. The identifier is formatted as a 20-character, alpha-numeric code based on ISO 17442. It connects to key information that enables clear and unique identification of legal",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '1.2.3a',
                        "answer_label": "Company LEI",
                        "answer_description": "Company LEI",
                        "answer_type": "textarea",
                        "answer_name": "answer_1.2.3a",
                        "answer_options": [

                        ]
                    },
                ]
            },

            {
                "id": '1.2.4',
                "field_label": "Are you a state-owned enterprise, non-profit organization, international organization, or other types of organization?",
                "field_name": "1.2.4",
                "field_description": "At the moment, the SBTi focuses on promoting corporate climate action and encourages companies from all sectors to demonstrate their leadership by committing to set targets and getting their targets validated by the SBTi. The initiative particularly welcomes companies from the highest emitting sectors as they play a crucial role in ensuring the transition towards a net-zero economy. Currently, the SBTi does not engage with cities, local governments, public sector institutions over 500 employees, educational institutions or non- profit organizations. The SBTi, encourages all these stakeholders to consider science-based target setting methods and other resources listed on our website and adapt them for their use, whenever possible.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '1.2.4a',
                        "answer_label": "select any one:",
                        "answer_description": " select any one:",
                        "answer_type": "radio",
                        "answer_name": "answer_1.2.4a",
                        "answer_options": [
                            { "key": "State-owned enterprise", "value": "State-owned enterprise" },
                            // { "key": "yes, an ISIN code", "value ": "Yes, an ISIN code" },
                            { "key": "Non-profit organizations", "value": "Non-profit organizations" },
                            { "key": "International organizations", "value": "International organizations" },
                            { "key": " Other", "value": " Other" },
                            { "key": "N/A, we are a company", "value": "N/A, we are a company" },
                        ]
                    }
                ]

            },
            {
                "id": '1.2.5',
                "field_label": " Headquarter's location (city and country)",
                "field_name": "1.2.5",
                "field_description": "Please indicate the city and country where your headquarters are located..",
                "is_required": false,
                "answers": [

                    {
                        "answer_id": '1.2.5a',
                        "answer_label": "City ",
                        "answer_description": "City",
                        "answer_type": "text",
                        "answer_name": "answer_1.2.5a",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '1.2.5b',
                        "answer_label": "Country",
                        "answer_description": "Country ",
                        "answer_type": "text",
                        "answer_name": "answer_1.2.5b",
                        "answer_options": [

                        ]
                    }
                ]

            },
            {
                "id": '1.2.6',
                "field_label": "Sector(s) the company operations in",
                "field_name": "1.2.6",
                "field_description": "Please list the main sector(s) your company operates in. No specific classification system is prescribed here, but if possible, we recommend the use of the SBTi sector classification. If your company is involved in multiple sectors, please estimate the percentage of activity in each sector. If your company is a real estate investment trust (REIT), please specify if it is an equity REIT or a mortgage REIT (mortgage REITs will have to validate targets using  the SBTi framework for Financial Institutions). Furthermore, financial institutions will need to follow the SBTi framework for Financial Institutions and submit targets using the SBTi Target Submission Form and Guidance for Financial Institutions. For a definition of financial institutions, please see the financial institution sector homepage. Note that the SBTi cannot officially validate or approve certain sectors' targets due to lack of an available methodology to assess the company's target(s) in a credible manner.*For the purposes of the target validation by the SBTi, “Oil & Gas” includes, but is not limited to, integrated Oil & Gas companies, Integrated Gas companies,   Exploration   &   Production   Pure",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '1.2.6a',
                        "answer_label": "Please also indicate if you are the following types of companies:",
                        "answer_description": "Please also indicate if you are the following types of companies:",
                        "answer_type": "checkbox",
                        "answer_name": "answer_1.2.6",
                        "answer_options": [
                            { "key": "Equity REIT ", "value": "Equity REIT " },
                            { "key": "Mortgage REIT", "value": "Mortgage REIT" },
                            { "key": "Automobile original equipment manufacturer (OEM)", "value": "Automobile original equipment manufacturer (OEM)" },
                            { "key": "Financial institution", "value": "Financial institution" },
                            { "key": "Oil and gas company*", "value": "Oil and gas company*" },
                            { "key": "Company with more than 50% revenue from the exploration, extraction, mining and/or production of oil, natural gas, coal, as well as, other fossil fuels.", "value": "Company with more than 50% revenue from the exploration, extraction, mining and/or production of oil, natural gas, coal, as well as, other fossil fuels." },
                        ]
                    }
                ]
            },
            {
                "id": '1.2.7',
                "field_label": "Please briefly describe the main operations and structure of your company. This includes a brief explanation of business activities and a clear overview of the different business segments of your company. Please also indicate the total number of employees.",
                "field_name": "1.2.7",
                "field_description": "Please briefly describe the main operations and structure of your company. This includes a brief explanation of the types of products/ services your company engages in and a clear overview of the different business segments of your company. Please also enter the total number of employees to help us understand if the regular validation option or the SME option is suitable for you.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '1.2.7a',
                        "answer_label": "General description:",
                        "answer_description": "General description:",
                        "answer_type": "textarea",
                        "answer_name": "answer_1.2.7a",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '1.2.7b',
                        "answer_label": "Please enter the total number of employees",
                        "answer_description": "Please enter the total number of employees",
                        "answer_type": "number",
                        "answer_name": "answer_1.2.7b",
                        "answer_options": [

                        ]
                    }
                ]
            },
            {
                "id": '1.2.8',
                "field_label": "Company's website",
                "field_name": "1.2.8",
                "field_description": "Please include your company's website address. If your company operates in a country in which English is not the dominate  spoken  language and your main company website is in a different language, please also include this website address.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '1.2.8a',
                        "answer_label": "Company's website URL (English)",
                        "answer_description": "Company's website URL (English)",
                        "answer_type": "textarea",
                        "answer_name": "answer_1.2.8a",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '1.2.8b',
                        "answer_label": "Company's website URL (original language version)",
                        "answer_description": "Company's website URL (original language version)",
                        "answer_type": "textarea",
                        "answer_name": "answer_1.2.8b",
                        "answer_options": [

                        ]
                    }
                ]
            },
            {
                "id": '1.2.9',
                "field_label": "Is your company a subsidiary of a larger holding company?",
                "field_name": "1.2.9",
                "field_description": "If your company is a subsidiary of a larger holding company that has its targets approved by the SBTi or is planning to submit their targets for approval, please select yes and indicate the name of the company and a short description of the relationship between the companies.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '1.2.9a',
                        "answer_label": "If yes, please indicate its name and description of company relationship",
                        "answer_description": "If yes, please indicate its name and description of company relationship ",
                        "answer_type": "radio",
                        "answer_name": "answer_1.2.9a",
                        "answer_options": [
                            { "key": "yes", "value": "Yes" },
                            { "key": "no", "value": "No" }
                        ]
                    },
                    {
                        "answer_id": '1.2.9b',
                        "answer_label": "If yes, has your parent company set science-based targets (SBTs) or is planning to do so?",
                        "answer_description": "If yes, has your parent company set science-based targets (SBTs) or is planning to do so? ",
                        "answer_type": "radio",
                        "answer_name": "answer_1.2.9b",
                        "answer_options": [
                            { "key": "yes", "value": "Yes" },
                            { "key": "no", "value": "No" }
                        ]
                    },

                ]
            },
            {
                "id": '1.2.10',
                "field_label": " Does your company have a subsidiary that has already set SBTs, or is planning to do so? If so, please indicate its name and whether their emissions are included in this target submission.",
                "field_name": "1.2.10",
                "field_description": "If your company is a holding company with subsidiaries that have targets approved by the SBTi or are planning to submit their targets for approval, please select yes and indicate the names of those subsidiaries.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '1.2.10a',
                        "answer_label": "If yes, please indicate its name ",
                        "answer_description": "If yes, please indicate its name ",
                        "answer_type": "radio",
                        "answer_name": "answer_1.2.10a",
                        "answer_options": [
                            { "key": "yes", "value": "Yes" },
                            { "key": "no", "value": "No" }
                        ]
                    },
                    {
                        "answer_id": '1.2.10b',
                        "answer_label": "If yes, are you including these subsidiary emissions in this target submission? ",
                        "answer_description": "If yes, are you including these subsidiary emissions in this target submission?",
                        "answer_type": "radio",
                        "answer_name": "answer_1.2.10b",
                        "answer_options": [
                            { "key": "yes", "value": "Yes" },
                            { "key": "no", "value": "No" }
                        ]
                    },
                ]
            },
            {
                "id": '1.2.11',
                "field_label": "If your company is involved in the sale, transmission, and distribution of fossil fuels, what percentage of your revenue is generated by these activities? Please provide the source of this information (e.g., financial report)",
                "field_name": "1.2.11",
                "field_description": "Answer this question if your company is involved in the sale, transmission, and distribution of fossil fuel or indicate 'N/A' if not relevant. Enter the percentage of revenue received from these activities. Please also provide the source of the percentage figure.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '1.2.11a',
                        "answer_label": "Percentage of revenue from these activities",
                        "answer_description": "Percentage of revenue from these activities",
                        "answer_type": "textarea",
                        "answer_name": "answer_1.2.11a",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '1.2.11b',
                        "answer_label": "%  revenue Source",
                        "answer_description": "%  revenue Source",
                        "answer_type": "textarea",
                        "answer_name": "answer_1.2.11b",
                        "answer_options": [

                        ]
                    }
                ]
            },
            {
                "id": '1.2.12',
                "field_label": "If your company is involved in financial institution related activities, what percentage of your revenue is generated by these activities?",
                "field_name": "1.2.12",
                "field_description": "Answer this question if your company is involved in any of the financial services activities that the SBTi defines as part of the financial institutions work or indicate 'N/A' if not relevant. Enter the percentage of revenue received from these activities. Please also provide the source of the percentage figure.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '1.2.12a',
                        "answer_label": "Percentage of revenue from these activities",
                        "answer_description": "Percentage of revenue from these activities",
                        "answer_type": "textarea",
                        "answer_name": "answer_1.2.12a",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '1.2.12b',
                        "answer_label": "%  revenue Source",
                        "answer_description": "%  revenue Source",
                        "answer_type": "textarea",
                        "answer_name": "answer_1.2.12b",
                        "answer_options": [

                        ]
                    }
                ]
            },
            {
                "id": '1.2.13',
                "field_label": "Technical contact (name, title, e-mail, and phone number)",
                "field_name": "1.2.13",
                "field_description": "Name, job title, e-mail and phone number of the person responsible for technical matters related to science-based targets within your company. This person will be the primary contact for our technical team. More than one contact may be listed if relevant, but please indicate who should be the primary contact.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '1.2.13a',
                        "answer_label": "Primary contact name: Title",
                        "answer_description": "Primary contact name: Titl",
                        "answer_type": "text",
                        "answer_name": "answer_1.2.13a",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '1.2.13b',
                        "answer_label": "Email",
                        "answer_description": "Email",
                        "answer_type": "text",
                        "answer_name": "answer_1.2.13b",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '1.2.13c',
                        "answer_label": "Phone number",
                        "answer_description": "Phone number",
                        "answer_type": "text",
                        "answer_name": "answer_1.2.13c",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '1.2.13d',
                        "answer_label": "Secondary contact name: Title",
                        "answer_description": "Secondary contact name: Title",
                        "answer_type": "text",
                        "answer_name": "answer_1.2.13d",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '1.2.13e',
                        "answer_label": "Email",
                        "answer_description": "Email",
                        "answer_type": "text",
                        "answer_name": "answer_1.2.13e",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '1.2.13f',
                        "answer_label": "Phone number",
                        "answer_description": "Phone number",
                        "answer_type": "text",
                        "answer_name": "answer_1.2.13f",
                        "answer_options": [

                        ]
                    }
                ]
            },
            {
                "id": '1.2.14',
                "field_label": "Communications contact (name, title and e-mail)",
                "field_name": "1.2.14",
                "field_description": "Name, job title, e-mail and phone number of the person responsible for communications matters related to science-based targets within your company. If your company's targets are approved, this person will be contacted by the SBTi communications team to coordinate the publication of the targets. You can list more than one contact if relevant, but please indicate who should be the primary contact.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '1.2.14a',
                        "answer_label": "Primary contact name: Title",
                        "answer_description": "Primary contact name: Title",
                        "answer_type": "text",
                        "answer_name": "answer_1.2.14a",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '1.2.14b',
                        "answer_label": "Email",
                        "answer_description": "Email",
                        "answer_type": "text",
                        "answer_name": "answer_1.2.14b",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '1.2.14c',
                        "answer_label": "Phone numbe",
                        "answer_description": "Phone number",
                        "answer_type": "text",
                        "answer_name": "answer_1.2.14c",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '1.2.14d',
                        "answer_label": "Secondary contact name: Titl",
                        "answer_description": "Secondary contact name: Title",
                        "answer_type": "text",
                        "answer_name": "answer_1.2.14d",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '1.2.14e',
                        "answer_label": "Emai",
                        "answer_description": "Email",
                        "answer_type": "text",
                        "answer_name": "answer_1.2.14e",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '1.2.14f',
                        "answer_label": "Phone number",
                        "answer_description": "Phone number",
                        "answer_type": "text",
                        "answer_name": "answer_1.2.14f",
                        "answer_options": [

                        ]
                    }
                ]
            },
            {
                "id": '1.2.15',
                "field_label": "Name and contact of consultancy hired to develop targets, if any.",
                "field_name": "1.2.15",
                "field_description": "If you hired a consultancy to develop or support the development of the targets submitted in this form, provide the name of the consultancy and a contact (name, e-mail, job title) within the consultancy, if possible. The SBTi is collecting this information in order to engage with consultancies that are working on science-based targets and cross-promote events related to this topic, as well as, to ensure that we are able to avoid any potential conflicts of interest.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '1.2.15a',
                        "answer_label": "Consultancy name",
                        "answer_description": "Consultancy name",
                        "answer_type": "text",
                        "answer_name": "answer_1.2.15a",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '1.2.15b',
                        "answer_label": "Contact name",
                        "answer_description": "Contact name",
                        "answer_type": "text",
                        "answer_name": "answer_1.2.15b",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '1.2.15c',
                        "answer_label": "Contact job title",
                        "answer_description": "Contact job title",
                        "answer_type": "text",
                        "answer_name": "answer_1.2.15c",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '1.2.15d',
                        "answer_label": "Contact email",
                        "answer_description": "Contact email",
                        "answer_type": "text",
                        "answer_name": "answer_1.2.15d",
                        "answer_options": [

                        ]
                    },
                ]
            },
            {
                "id": 2,
                "field_label": "GHG Inventory",
                "field_name": "heading",
                "is_required": false,
            },
            {
                "id": 2.1,
                "field_label": "GHG INVENTORY GENERAL QUESTIONS",
                "field_name": "subheading",
                "is_required": false,
            },
            {
                "id": '2.1.1',
                "field_label": "Does your inventory follow the GHG Protocol Corporate Standard? If not, list and explain any deviation from its requirements.",
                "field_name": "2.1.1",
                "field_description": "Indicate if your inventory is in accordance with the GHG Protocol Corporate Standard. Please indicate any deviation from the standard with reference to the chapter and page in question, as well as the justification for why the standard was not followed.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '2.1.1a',
                        "answer_label": "select any one ",
                        "answer_description": "select any on ",
                        "answer_type": "radio",
                        "answer_name": "answer_2.1.1a",
                        "answer_options": [
                            { "key": "yes", "value": "Yes" },
                            { "key": "no", "value": "No" }
                        ]
                    },
                    {
                        "answer_id": '2.1.1b',
                        "answer_label": "If not, explain deviations ",
                        "answer_description": "If not, explain deviations ",
                        "answer_type": "textarea",
                        "answer_name": "answer_2.1.1b",
                        "answer_options": [

                        ]
                    },
                ]
            },
            {
                "id": '2.1.2',
                "field_label": "State the consolidation approach used to calculate your GHG inventory and why it was chosen.",
                "field_name": "2.1.2",
                "field_description": "State whether you used the equity share or the control approach for your GHG inventory. If you used a control approach, state whether it was an operational or financial control approach. For more information on this please refer to Chapter 3 “Setting Organizational Boundaries” of the GHG Protocol Corporate Standard.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '2.1.2a',
                        "answer_label": "Select one of the following options  ",
                        "answer_description": "Select one of the following options ",
                        "answer_type": "radio",
                        "answer_name": "answer_2.1.2a",
                        "answer_options": [
                            { "key": "Equity share ", "value": "Equity share " },
                            { "key": "Financial control", "value": "Financial control" },
                            { "key": "Operational control Briefly explain why it was chosen:", "value": "Operational control Briefly explain why it was chosen:" },
                        ]
                    },
                ]
            },
            {
                "id": '2.1.3',
                "field_label": "Has your company experienced any recent significant change in your company structure e.g., following recent acquisitions, divestments and/or mergers?",
                "field_name": "2.1.3",
                "field_description": "Significant change is defined as a cumulative change of five percent or larger in an organization's total base year emissions (CO2e).For detailed guidelines, please review Chapter 5 of the GHG Protocol Corporate Standard Tracking Emissions Over Time, the section entitled “Target Recalculation Protocol” in the",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '2.1.3a',
                        "answer_label": "Select one of the following options:  ",
                        "answer_description": "Select one of the following option ",
                        "answer_type": "radio",
                        "answer_name": "answer_2.1.3a",
                        "answer_options": [
                            { "key": "yes", "value": "Yes" },
                            { "key": "no", "value": "No" }]
                    },
                ]
            },
            {
                "id": '2.1.4',
                "field_label": "If your company has marked “Yes” in question 2.1.3, has the base year emissions data been retroactively recalculated to reflect this significant change? Please provide a brief description on how the base year data has been adjusted.",
                "field_name": "2.1.4",
                "field_description": "Significant change is defined as a cumulative change of five percent or larger in an organization's total base year emissions (CO2e).For detailed guidelines, please review Chapter 5 of the GHG Protocol Corporate Standard Tracking Emissions Over Time and in the section entitled “Reporting and Recalculation” in the SBTi Criteria. The SBTi will consider recent a timeframe of two years from the date the target is submitted for validation.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '2.1.4a',
                        "answer_label": "Select one of the following options ",
                        "answer_description": "Select one of the following options ",
                        "answer_type": "radio",
                        "answer_name": "answer_2.1.4a",
                        "answer_options": [
                            { "key": "yes ", "value": "Yes " },
                            { "key": "no", "value": "No" },
                        ]
                    },
                    {
                        "answer_id": '2.1.4b',
                        "answer_label": "Brief description ",
                        "answer_description": "Brief description ",
                        "answer_type": "textarea",
                        "answer_name": "answer_2.1.4b",
                        "answer_options": [

                        ]
                    },
                ]
            },
            {
                "id": '2.1.5',
                "field_label": "Have you included emissions from all subsidiaries and joint ventures in your inventory and target boundary in accordance with the chosen consolidation approach?",
                "field_name": "2.1.5",
                "field_description": "Per GHG Protocol Corporate Standard, parent companies, with the ability to direct the financial and operating policies of the subsidiaries, shall include 100% of subsidiaries' emissions under operational or financial control approach. If the equity share approach is chosen, equity share of",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '2.1.5a',
                        "answer_label": "Select one of the following options: ",
                        "answer_description": "Select one of the following options: ",
                        "answer_type": "radio",
                        "answer_name": "answer_2.1.5a",
                        "answer_options": [
                            { "key": "yes ", "value": "Yes " },
                            { "key": "no", "value": "No" },
                            { "key": "n/a", "value": "N/A" },
                        ]
                    },
                    {
                        "answer_id": '2.1.5b',
                        "answer_label": "If not, which subsidiaries/ joint ventures have you not included and why? ",
                        "answer_description": "If not, which subsidiaries/ joint ventures have you not included and why? ",
                        "answer_type": "textarea",
                        "answer_name": "answer_2.1.5b",
                        "answer_options": [

                        ]
                    },
                ]
            },
            {
                "id": '2.1.6',
                "field_label": "Do you have subsidiaries and/or joint ventures that occur outside your organizational boundary and consolidation approach that have therefore not been included?",
                "field_name": "2.1.6",
                "field_description": "Per GHG Protocol Corporate Standard, parent companies, with the ability to direct the financial and operating policies of the subsidiaries, shall include 100% of subsidiaries' emissions under operational or financial control approach. If the equity share approach is chosen, equity share of subsidiaries' emissions shall be included in the parent company's inventory.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '2.1.6a',
                        "answer_label": "Select one of the following options ",
                        "answer_description": "Select one of the following option ",
                        "answer_type": "radio",
                        "answer_name": "answer_2.1.6a",
                        "answer_options": [
                            { "key": "yes ", "value": "Yes " },
                            { "key": "no", "value": "No" },
                            { "key": "n/a", "value": "N/A" },
                        ]
                    },
                    {
                        "answer_id": '2.1.6b',
                        "answer_label": "If not, which subsidiaries/ joint ventures have you not included and why? ",
                        "answer_description": "If not, which subsidiaries/ joint ventures have you not included and why? ",
                        "answer_type": "textarea",
                        "answer_name": "answer_2.1.6b",
                        "answer_options": [

                        ]
                    },
                ]
            },
            {
                "id": '2.1.7',
                "field_label": "For any transport-related emissions, have they been calculated on a well-to-wheel basis?",
                "field_name": "2.1.7",
                "field_description": "Transport-related emissions should follow the relevant sector guidance wherein emissions are reported on a well-to-wheel basis - this includes both the direct use emissions from fuel combustion (Tank-to-Wheel) but also upstream emissions related to fuel production and distribution (Well-to-Tank). Any transport- related emissions within the value chain, including subcontracted transport and other transportation outside the organizational boundaries should also follow the relevant sector guidance.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '2.1.7a',
                        "answer_label": "Select one of the following options ",
                        "answer_description": "Select one of the following option ",
                        "answer_type": "radio",
                        "answer_name": "answer_2.1.7a",
                        "answer_options": [
                            { "key": "yes ", "value": "Yes " },
                            { "key": "no", "value": "No" },
                        ]
                    },
                    {
                        "answer_id": '2.1.7b',
                        "answer_label": "If not, explain deviations",
                        "answer_description": "If not, explain deviations",
                        "answer_type": "textarea",
                        "answer_name": "answer_2.1.7b",
                        "answer_options": [

                        ]
                    },
                ]
            },
            {
                "id": '2.1.8',
                "field_label": "Please specify the base year and the most recent year used in the GHG inventory table. If different for different scopes, specify for each.",
                "field_name": "2.1.8",
                "field_description": "State which base year the information in the white section of Table 1 below refers to. For scope 3, if the same base year information is not available, you may use a different year, though the same base year for all scopes is preferred. State which year the information in the grey section of GHG inventory table refers to. This should be the most recent year for which complete GHG emissions inventory data is available, specifically 2019 or later.* If the data is from different years for different scopes, specify for each.* For targets submitted for validation in 2022, the most recent inventory data submitted must be for 2019 at the earliest.Historically, the SBTi has only allowed two years prior as valid most recent year inventories, however, due to the COVID- 19 pandemic, the SBTi will accept 2019 inventories in 2022.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '2.1.8a',
                        "answer_label": "Scope 1 and 2",
                        "answer_description": "Scope 1 and 2",
                        "answer_type": "text",
                        "answer_name": "answer_2.1.8a",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '2.1.8b',
                        "answer_label": "Base year",
                        "answer_description": "Base year",
                        "answer_type": "text",
                        "answer_name": "answer_2.1.8b",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '2.1.8c',
                        "answer_label": "Most recent year",
                        "answer_description": "Most recent year",
                        "answer_type": "text",
                        "answer_name": "answer_2.1.8c",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '2.1.8d',
                        "answer_label": "Scope 3",
                        "answer_description": "Scope 3",
                        "answer_type": "text",
                        "answer_name": "answer_2.1.8d",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '2.1.8e',
                        "answer_label": "Base year",
                        "answer_description": "Base year",
                        "answer_type": "text",
                        "answer_name": "answer_2.1.8e",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '2.1.8f',
                        "answer_label": "Most recent year",
                        "answer_description": "Most recent year",
                        "answer_type": "text",
                        "answer_name": "answer_2.1.8f",
                        "answer_options": [

                        ]
                    },
                ]
            },
            {
                "id": 2.2,
                "field_label": "SCOPE 1 AND 2 QUESTIONS",
                "field_name": "subheading",
                "is_required": false,
            },
            {
                "id": '2.2.1',
                "field_label": " Describe the primary operations and activities that account for emissions in scope 1 and 2. ",
                "field_name": "2.2.1",
                "field_description": "For scope 1 and 2, please describe the primary activities of your company that are included in the inventory. If your company operates in different sectors, specify the activities for each. For more information on emissions scopes, refer to Chapter 4 “Setting Operational Boundaries” of the GHG Protocol Corporate Standard.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '2.2.1a',
                        "answer_label": "Scope 1 ",
                        "answer_description": "Scope 1 ",
                        "answer_type": "textarea",
                        "answer_name": "answer_2.2.1a",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '2.2.1b',
                        "answer_label": "Scope 2 ",
                        "answer_description": "Scope 2 ",
                        "answer_type": "textarea",
                        "answer_name": "answer_2.2.1b",
                        "answer_options": [

                        ]
                    },
                ]
            },
            {
                "id": '2.2.2',
                "field_label": " Which method will the company use to track performance towards its scope 2 target?",
                "field_name": "2.2.2",
                "field_description": "State whether you plan to use the location- based or the market-based method to calculate your scope 2 emissions in future inventories and track progress towards your scope 2 target(s). If you plan to set two scope 2 targets, one for the market-based approach and one for the location-based approach, please specify the method for each target using the Target ID. For more information on this please refer to Chapter 4 “Scope 2 Accounting Methods” of the GHG Protocol Scope 2 Guidance.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '2.2.2a',
                        "answer_label": "Select one of the following options:",
                        "answer_description": "select in any option",
                        "answer_type": "radio",
                        "answer_name": "answer_2.2.2a",
                        "answer_options": [
                            { "key": "Location-based", "value": "Location-based" },
                            { "key": "Market-based", "value": "Market-based" },
                        ]
                    },
                ]
            },
            {
                "id": '2.2.3',
                "field_label": "If submitting a renewable electricity target, please specify the share of electricity consumption from  renewable electricity procurement in the base year, most recent year, and the target year (in %).",
                "field_name": "2.2.3",
                "field_description": "As indicated by the SBTi Criterion - Renewable Electricity, targets to source renewable electricity at a rate that is considered ambitious are an acceptable alternative to scope 2 emission reduction targets.If you are including a RE procurement target, please provide your company's share of renewable electricity consumption in the base year, the most recent year and the expected share in the target year. If you don't have a RE procurement target, select N/A.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '2.2.3a',
                        "answer_label": "Base year",
                        "answer_description": "Base year",
                        "answer_type": "text",
                        "answer_name": "answer_2.2.3a",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '2.2.3b',
                        "answer_label": "Most recent year",
                        "answer_description": "Most recent year",
                        "answer_type": "text",
                        "answer_name": "answer_2.2.3b",
                        "answer_options": []
                    },
                    {
                        "answer_id": '2.2.3c',
                        "answer_label": "Target year (expected)",
                        "answer_description": "Target year (expected)",
                        "answer_type": "text",
                        "answer_name": "answer_2.2.3c",
                        "answer_options": [
                        ]
                    },
                    {
                        "answer_id": '2.2.3d',
                        "answer_label": "Select N/A ",
                        "answer_description": "Select N/A ",
                        "answer_type": "radio",
                        "answer_name": "answer_2.2.3d",
                        "answer_options": [
                            { "key": "N/A", "value": "N/A" },
                        ]
                    },
                ]
            },
            {
                "id": 2.3,
                "field_label": "BIOENERGY QUESTIONS",
                "field_name": "subheading",
                "is_required": false,
            },
            {
                "id": '2.3.1',
                "field_label": "Does your company generate any CO2 emissions from bioenergy use/production and/or biomass feedstock production for bioenergy? If yes, please provide information on the methodology to estimate CO2 emissions from biofuels/biomass combustion and/or CO2 removals from the bioenergy sources used (if any).",
                "field_name": "2.3.1",
                "field_description": "Please select yes if your company uses and/or produces bioenergy (biofuels and/or biomass) as defined by IEA*. *Bioenergy is energy generated from the conversion of solid, liquid and gaseous products  derived   from   biomass.   Biomass is any organic matter, i.e., biological material, available on a renewable basis. This includes feedstock derived from animals or plants, such as wood and agricultural crops, and organic waste from municipal and industrial sources. Consider both the base year and the most recent year. Companies should provide justifications for why such sources are deemed. renewable. The SBTi criteria requires companies to provide information about direct biogenic emissions and removals associated with bioenergy, and to include these in the target boundary.Companies are also recommended to report non-bioenergy related biogenic emissions alongside the inventory. Carbon sequestration not related to bioenergy feedstock are currently not accepted to count as progress towards SBTs or to net emissions in the inventory. The SBTi will develop more guidance on how to treat other biogenic emissions and carbon removals in the future.If biogenic emissions from biomass and biofuels are considered carbon neutral, the company must provide justification of the underlying assumptions.For the methodology section, please describe the accounting method used to estimate the emissions and/or removals included in question 2.3.3. Please include a description of the bioenergy sources used, the emissions factors    used    and    any    other    relevant",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": "2.3.1a",
                        "answer_label": "select that apply",
                        "answer_description": "select that apply",
                        "answer_type": "radio",
                        "answer_name": "answer_2.3.1a",
                        "answer_options": [
                            { "key": "Yes", "value": "Yes" },
                            { "key": "No Methodology:", "value": "No Methodology" },
                        ]
                    },
                ]
            },
            {
                "id": '2.3.2',
                "field_label": "Are direct land use change emissions relevant to your company?",
                "field_name": "2.3.2",
                "field_description": "At the moment, the GHG protocol  provides only limited guidance on agriculture, forestry and other land-use (AFOLU) emissions accounting and there are no sector-specific SBT setting methodologies available for companies in land-intensive sectors that include AFOLU emissions. The Science Based Targets initiative is undertaking a sector development project, the SBTi Forest,  Land and Agriculture project (“SBTi FLAG”), led by WWF, to address this methodology gap. The effort will focus on the development of methods and guidance to enable the food, agriculture, and forest sectors to set science- based targets (SBTs) that include deforestation, and possibly other land-related impacts. In parallel to this effort, WRI and WBCSD are leading the development of three new GHG Protocol Standards on how companies should account for GHG emissions and removals in their annual inventories. The three standards will cover: 1.  Carbon Removals and Sequestration, 2. Land Sector Emissions and Removals and 3. Bioenergy. The FLAG project and the new GHG Protocol Standards are complementary  work  streams that will provide the infrastructure needed for corporate target setting, accounting, and reporting of AFOLU-related emissions.Land use change emissions in SBTs (non- FLAG) relates with bioenergy only. Other LUC emissions (related to food, forestry and any other land intensive sector) must be considered in a separated (FLAG) target.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '2.3.2a',
                        "answer_label": "Select any of the following",
                        "answer_description": "Select any of the following",
                        "answer_type": "radio",
                        "answer_name": "answer_2.3.2a",
                        "answer_options": [
                            { "key": "yes", "value": "Yes" },
                            { "key": "no", "value": "No" },
                        ]
                    },
                    {
                        "answer_id": '2.3.2b',
                        "answer_label": "Are you calculating these emissions?",
                        "answer_description": "Are you calculating these emissions?",
                        "answer_type": "radio",
                        "answer_name": "answer_2.3.2b",
                        "answer_options": [
                            { "key": "yes", "value": "Yes" },
                            { "key": "no", "value": "No" },
                            { "key": "N/A, these emissions are not relevant", "value": "N/A, these emissions are not relevant" },
                        ]
                    },
                    {
                        "answer_id": '2.3.2c',
                        "answer_label": "If yes, what method are you using to calculate these emissions?",
                        "answer_description": "Are these emissions included in your inventory and/or target boundary?",
                        "answer_type": "radio",
                        "answer_name": "answer_2.3.2c",
                        "answer_options": [
                            { "key": "Calculated and included in the inventory only", "value": "Calculated and included in the inventory only" },
                            { "key": "Calculated and included in the inventory and target boundary", "value": "Calculated and included in the inventory and target boundary" },
                            { "key": "Calculated but not included in the inventory", "value": "Calculated but not included in the inventory" },
                        ]
                    }
                ]
            },
            {
                "id": '2.3.3',
                "field_label": " Bioenergy Accounting - Reported Separately from the Scopes Required: CO2 emissions from bioenergy use/ production and/or biomass feedstock production for bioenergy",
                "field_name": "2.3.3",
                "field_description": "CO2 emissions from bioenergy use/production and/or biomass feedstock production for bioenergy. CO2 emissions from the combustion, processing and distribution phase of bioenergy and the land use emissions and removals associated with bioenergy feedstocks shall be included in the target boundary (in scopes 1, 2, and/or 3, as relevant).Land-related emissions accounting shall include CO2 emissions from direct land use change (LUC) and non-LUC emissions, inclusive of N2O and CH4 emissions from land use management.Including emissions association with indirect LUC is optional.Furthermore, as indicated by the GHG Protocol Corporate Standard, direct CO2 emissions from the combustion of biomass shall be reported separately from the scopes.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '2.3.3a',
                        "answer_label": " Base Year (tCO2e) Scope 1: (Example input format: 1,300,526.50)",
                        "answer_description": "Base Year (tCO2e) Scope 1: (Example input format:1,300,526.50)",
                        "answer_type": "number",
                        "answer_name": "answer_2.3.3a",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '2.3.3b',
                        "answer_label": " Base Year (tCO2e) Scope 2: (Example input format: 1,300,526.50)",
                        "answer_description": "Base Year (tCO2e) Scope 2: (Example input format: 1,300,526.50)",
                        "answer_type": "number",
                        "answer_name": "answer_2.3.3b",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '2.3.3c',
                        "answer_label": " Base Year (tCO2e) Scope 3:( Please indicate the relevant category(ies): Example input format: 1,300,526.50)",
                        "answer_description": "Base Year (tCO2e) Scope 3:( Please indicate the relevant category(ies): Example input format: 1,300,526.50)",
                        "answer_type": "number",
                        "answer_name": "answer_2.3.3c",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '2.3.3d',
                        "answer_label": " Most Recent Year (tCO2e) Scope 1: (Example input format:  1,300,526.50)",
                        "answer_description": "Most Recent Year (tCO2e) Scope 1: (Example input format:  1,300,526.50)",
                        "answer_type": "number",
                        "answer_name": "answer_2.3.3d",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '2.3.3e',
                        "answer_label": " Most Recent Year (tCO2e) Scope 2: (Example input format:  1,300,526.50)",
                        "answer_description": "Most Recent Year (tCO2e) Scope 2: (Example input format:  1,300,526.50)",
                        "answer_type": "number",
                        "answer_name": "answer_2.3.3e",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '2.3.3f',
                        "answer_label": " Most Recent Year (tCO2e) Scope 3: (Please indicate the relevant category(ies): Example input format: 1,300,526.50)",
                        "answer_description": "Most Recent Year (tCO2e) Scope 3: (Please indicate the relevant category(ies): Example input format: 1,300,526.50)",
                        "answer_type": "number",
                        "answer_name": "answer_2.3.3f",
                        "answer_options": [

                        ]
                    },
                ]
            },
            {
                "id": '2.3.3.1',
                "field_label": " Please confirm which activities the CO2 emissions from bioenergy use/ production and/or biomass feedstock production for bioenergy covers",
                "field_name": "2.3.3.1",
                "field_description": "Please clarify which activities the CO2 emissions from bioenergy use/ production and/or biomass feedstock production for bioenergy covers e.g., direct CO2 emissions from combustion of biofuels and/or biomass feedstocks and/or direct CO2 emissions from production of biomass feedstocks.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '2.3.3.1a',
                        "answer_label": "About activities",
                        "answer_description": "About activities",
                        "answer_type": "textarea",
                        "answer_name": "answer_2.3.3.1a",
                        "answer_options": [

                        ]
                    },

                ]
            },
            {
                "id": '2.3.3.2',
                "field_label": " Estimated carbon removals related to biomass feedstock production for bioenergy",
                "field_name": "2.3.3.2",
                "field_description": "Estimated carbon removals related to biomass feedstocks for bioenergy: companies are encouraged to report gross emissions and gross removals from bioenergy feedstocks separately.The GHG Protocol Corporate Standard Annex B provides limited guidance on how to account for these removals, which you can refer to. As there is no consensus method yet on how to account for these removals, you should disclose the method used to estimate these emissions in question 2.3.1.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '2.3.3.2a',
                        "answer_label": " Base Year (tCO2e) Scope 1: (Example input format: 1,300,526.50)",
                        "answer_description": "Base Year (tCO2e) Scope 1: (Example input format:1,300,526.50)",
                        "answer_type": "number",
                        "answer_name": "answer_2.3.3.2a",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '2.3.3.2b',
                        "answer_label": " Base Year (tCO2e) Scope 2: (Example input format: 1,300,526.50)",
                        "answer_description": "Base Year (tCO2e) Scope 2: (Example input format: 1,300,526.50)",
                        "answer_type": "number",
                        "answer_name": "answer_2.3.3.2b",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '2.3.3.2c',
                        "answer_label": " Base Year (tCO2e) Scope 3:( Please indicate the relevant category(ies): Example input format: 1,300,526.50)",
                        "answer_description": "Base Year (tCO2e) Scope 3:( Please indicate the relevant category(ies): Example input format: 1,300,526.50)",
                        "answer_type": "number",
                        "answer_name": "answer_2.3.3.2c",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '2.3.3.2d',
                        "answer_label": " Most Recent Year (tCO2e) Scope 1: (Example input format:  1,300,526.50)",
                        "answer_description": "Most Recent Year (tCO2e) Scope 1: (Example input format:  1,300,526.50)",
                        "answer_type": "number",
                        "answer_name": "answer_2.3.3.2d",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '2.3.3.2e',
                        "answer_label": " Most Recent Year (tCO2e) Scope 2: (Example input format:  1,300,526.50)",
                        "answer_description": "Most Recent Year (tCO2e) Scope 2: (Example input format:  1,300,526.50)",
                        "answer_type": "number",
                        "answer_name": "answer_2.3.3.2e",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '2.3.3.2f',
                        "answer_label": " Most Recent Year (tCO2e) Scope 3: (Please indicate the relevant category(ies): Example input format: 1,300,526.50)",
                        "answer_description": "Most Recent Year (tCO2e) Scope 3: (Please indicate the relevant category(ies): Example input format: 1,300,526.50)",
                        "answer_type": "number",
                        "answer_name": "answer_2.3.3.2f",
                        "answer_options": [

                        ]
                    },
                ]
            },
            {
                "id": '2.3.4',
                "field_label": "Do you have biogenic N2O and CH4 emissions? If so, have you included them in the inventory of the relevant scope(s)?",
                "field_name": "2.3.4",
                "field_description": "Please clarify if your company has biogenic N2O and CH4 emission and whether they have been included within the inventory of the relevant scope(s).",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '2.3.4a',
                        "answer_label": "Select any of the following:",
                        "answer_description": "Select any of the following:",
                        "answer_type": "radio",
                        "answer_name": "answer_2.3.4a",
                        "answer_options": [
                            { "key": "yes", "value": "Yes" },
                            { "key": "no", "value": "No" },
                            { "key": "N/A", "value": "N/A" },
                        ]
                    },
                ]
            },
            {
                "id": '2.3.5',
                "field_label": "If you reported biomass/biofuels CO2 emissions and CO2 removals related to biomass /biofuels feedstocks in question 2.3.3, are these emissions included within the target(s) boundary? Under which target(s) are they included?",
                "field_name": "2.3.5",
                "field_description": "As per the SBTi Criterion - Bioenergy accounting, if you reported emissions from bioenergy and/or removals related to biomass/biofuel feedstocks in question 2.3.3, these must be included in the target boundary. If your targets are approved, you should also track those emissions and removals throughout the target period.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '2.3.5a',
                        "answer_label": "Select any of the following",
                        "answer_description": "Select any of the following",
                        "answer_type": "radio",
                        "answer_name": "answer_2.3.5a",
                        "answer_options": [
                            { "key": "yes", "value": "Yes" },
                            { "key": "no", "value": "No" },
                            { "key": "N/A", "value": "N/A" },
                        ]
                    },
                    {
                        "answer_id": '2.3.5b',
                        "answer_label": "If yes, please specify under which target(s) IDs",
                        "answer_description": "If yes, please specify under which target(s) IDs",
                        "answer_type": "textarea",
                        "answer_name": "answer_2.3.5b",
                        "answer_options": []
                    },
                ]
            },
            {
                "id": '2.3.6',
                "field_label": "If your targets include bioenergy, do you agree to include the bioenergy footnote in the target language?",
                "field_name": "2.3.6",
                "field_description": "For targets that include bioenergy, the target language must include the following footnote: *The target boundary includes land-related emissions and removals from bioenergy feedstocks.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '2.3.6a',
                        "answer_label": "Select any of the following",
                        "answer_description": "Select any of the following",
                        "answer_type": "radio",
                        "answer_name": "answer_2.3.6a",
                        "answer_options": [
                            { "key": "yes", "value": "Yes" },
                            { "key": "no", "value": "No" },
                            { "key": "N/A", "value": "N/A" },
                        ]
                    },
                ]
            },
            {
                "id": '2.3.7',
                "field_label": "If your company is part of the Food, Agriculture and Forest sectors, do you confirm that you agree to recalculate your targets in line with the FLAG method when available?",
                "field_name": "2.3.7",
                "field_description": "Companies in Forest, Land and Agriculture (FLAG) sectors will be required to update their GHG inventories in line with  the upcoming GHG Protocol Guidance on Carbon Removals and Land Use. Where this GHG inventory update triggers a target recalculation as described    in    the    SBTi    Criteria    and Recommendations, companies  are  required to recalculate their targets in line with the FLAG method.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '2.3.7a',
                        "answer_label": "Select one of the following options",
                        "answer_description": "select any option",
                        "answer_type": "radio",
                        "answer_name": "answer_2.3.7a",
                        "answer_options": [
                            { "key": "yes", "value": "Yes" },
                            { "key": "no", "value": "No" },
                            { "key": "N/A", "value": "N/A" },
                        ]
                    },
                ]
            },
            {
                "id": 2.4,
                "field_label": "SCOPE 3 QUESTIONS",
                "field_name": "subheading",
                "is_required": false,
            },
            {
                "id": '2.4.1',
                "field_label": "Has the company completed a scope 3 screening and/or inventory of all categories?",
                "field_name": "2.4.1",
                "field_description": "State whether your company has completed either a scope 3 screening or an inventory. If yes, specify whether it was a screening or an inventory.A scope 3 screening is a high- level evaluation to estimate the scope 3 emissions categories that are relevant to your company and indicate which ones are expected to be most  significant.A scope 3 screening needs to be completed for all scope 3 categories, regardless of whether a company deems these scope 3 categories to be de minimis.The SBTi encourages companies to develop scope 3 inventories, but a screening is acceptable for an SBT submission, and the first and minimum step a company should complete.The GHG Protocol, in collaboration with Quantis, have released a free scope 3 screening tool, The Scope 3 Evaluator.This tool asks a number of relatively simple questions and can be used by companies of all sizes and all sectors. For more information on scope 3 emissions inventory and screening, refer to the Corporate Value Chain (Scope 3) Accounting and Reporting Standard.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '2.4.1a',
                        "answer_label": "Select one of the following options",
                        "answer_description": "Select one of the following options",
                        "answer_type": "radio",
                        "answer_name": "answer_2.4.1a",
                        "answer_options": [
                            { "key": "yes", "value": "Yes" },
                            { "key": "no", "value": "No" },
                        ]
                    },
                    {
                        "answer_id": '2.4.1b',
                        "answer_label": "If yes, please specify",
                        "answer_description": "If yes, please specify",
                        "answer_type": "radio",
                        "answer_name": "answer_2.4.1b",
                        "answer_options": [
                            { "key": "Screening", "value": "Screening" },
                            { "key": "Inventory", "value": "Inventory" },
                            { "key": "Hybrid approach using both screening and inventory (e.g., inventory of category 1 and screening of category 2-15)", "value": "Hybrid approach using both screening and inventory (e.g., inventory of category 1 and screening of category 2-15)" },
                        ]
                    },
                    {
                        "answer_id": '2.4.1c',
                        "answer_label": "For which scope 3 categories did you perform a screening? Category(ies)",
                        "answer_description": "For which scope 3 categories did you perform a screening? Category(ies)",
                        "answer_type": "textarea",
                        "answer_name": "answer_2.4.1c",
                        "answer_options": [
                        ]
                    },
                    {
                        "answer_id": '2.4.1d',
                        "answer_label": "For which scope 3 categories did you perform an inventory? Category(ies)",
                        "answer_description": "For which scope 3 categories did you perform an inventory? Category(ies)",
                        "answer_type": "textarea",
                        "answer_name": "answer_2.4.1d",
                        "answer_options": []
                    },
                ]
            },
            {
                "id": '2.4.2',
                "field_label": "If you would like to have SBTi officially approve a target to reduce scope 3 emissions that fall outside the minimum boundary of scope 3 categories (“optional”), please enter basic information about this category of emissions, and explain how you plan to reduce these emissions.",
                "field_name": "2.4.2",
                "field_description": "Companies may request to include targets to reduce optional scope 3 emissions in the official target language. Please first describe the category, report the base year and most recent year emissions, and indicate if these optional scope 3 emissions have been included in the GHG inventory table.Please also describe your plans to reduce these emissions for SBTi to determine whether the actions are credible for these targets to be approved. If the targets are deemed ambitious, credible, and thus can be published by SBTi, the target language needs to be separate from the other approved targets. For more information on optional scope 3 targets, please refer to the Target Validation Protocol.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '2.4.2a',
                        "answer_label": "N/A, no optional scope 3 target submitted Optional Scope 3 category name: enter name per  definition of the GHGP Scope 3 standard Briefly describe the activity in this category: describe activity How do you plan to reduce these emissions?",
                        "answer_description": "N/A, no optional scope 3 target submitted Optional Scope 3 category name: enter name per  definition of the GHGP Scope 3 standard Briefly describe the activity in this category: describe activity How do you plan to reduce these emissions?",
                        "answer_type": "textarea",
                        "answer_name": "answer_2.4.2a",
                        "answer_options": [
                        ]
                    },
                ]
            },
            {
                "id": 2.5,
                "field_label": " EXCLUSIONS QUESTIONS",
                "field_name": "subheading",
                "is_required": false,
            },
            {
                "id": '2.5.1',
                "field_label": "Describe and justify any exclusions from the inventory.",
                "field_name": "2.5.1",
                "field_description": "Please list any exclusions made from the inventory that should be within  the consolidation boundary you used per the GHG Protocol (Question 2.1.2). For each type of exclusion listed (greenhouse gases, facilities, activities, geographies, operations, and/or others), describe the exclusion(s), if any, and provide a justification (e.g., emissions from this gas are below the de minimis threshold). Note that not being able to measure a gas that is significant is not a valid justification.For greenhouse gases: select the ones that were excluded from the inventory and provide an explanation. The GHG Protocol Corporate Standard requires seven gases to be included in inventories: carbon dioxide (CO2), methane (CH4), nitrous oxide  (N2O), hydrofluorocarbons (HFC),  perfluorocarbons (PFC), sulfur hexafluoride (SF6) and nitrogen trifluoride  (NF3).  Additional  information  on the accounting amendment that requires NF3 to be included in GHG inventories can be found here.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '2.5.1a',
                        "answer_label": "Greenhouse gases excluded",
                        "answer_description": "Greenhouse gases excluded",
                        "answer_type": "radio",
                        "answer_name": "answer_2.5.1a",
                        "answer_options": [
                            { "key": "CO2", "value": "CO2" },
                            { "key": "CH4", "value": "CH4" },
                            { "key": "N2O", "value": "N2O" },
                            { "key": "HFC", "value": "HFC" },
                            { "key": "PFC", "value": "PFC" },
                            { "key": "SF6", "value": "SF6" },
                            { "key": "NF3", "value": "NF3" },
                            { "key": "None Facilities excluded", "value": "None Facilities excluded" }
                        ]
                    },
                    {
                        "answer_id": '2.5.1b',
                        "answer_label": "Activities excluded",
                        "answer_description": "Activities excluded",
                        "answer_type": "textarea",
                        "answer_name": "answer_2.5.1b",
                        "answer_options": [
                        ]
                    },
                    {
                        "answer_id": '2.5.1c',
                        "answer_label": "Geographies excluded",
                        "answer_description": "Geographies excluded",
                        "answer_type": "textarea",
                        "answer_name": "answer_2.5.1c",
                        "answer_options": [
                        ]
                    },
                    {
                        "answer_id": '2.5.1d',
                        "answer_label": "Operations excluded Other exclusions",
                        "answer_description": "Operations excluded Other exclusions",
                        "answer_type": "textarea",
                        "answer_name": "answer_2.5.1d",
                        "answer_options": [
                        ]
                    },
                ]
            },
            {
                "id": '2.5.2',
                "field_label": "How much of scope 1 and 2 emissions do the exclusions mentioned in question 2.5.1 represent? Estimate the percentage for each scope.How much of scope 3 emissions do exclusions mentioned in question 2.5.1 represent? Estimate the percentage for each category.(The following fields must be filled in if you indicated any exclusion in 2.5.1. Please enter zero if there is no exclusion. )",
                "field_name": "2.5.2",
                "field_description": "For scope 1 and 2, estimate the %  of emissions excluded considering the sum of exclusions stated in question 2.5.1. Note that according to SBTi criteria, companies may exclude up to 5% of scope 1  and scope 2 emissions combined in their inventory and target.For scope 3, estimate the % of emissions excluded considering the sum of exclusions stated in question 2.5.1. Note that not being able to measure a scope 3 category is not a valid justification.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '2.5.2a',
                        "answer_label": "% excluded from scope 1",
                        "answer_description": "% excluded from scope 1",
                        "answer_type": "text",
                        "answer_name": "answer_2.5.2a",
                        "answer_options": [

                        ],
                    },
                    {
                        "answer_id": '2.5.2b',
                        "answer_label": "% excluded from scope 2",
                        "answer_description": "% excluded from scope 2",
                        "answer_type": "text",
                        "answer_name": "answer_2.5.2b",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '2.5.2c',
                        "answer_label": "% excluded from scopes 1 and 2 combined",
                        "answer_description": "% excluded from scopes 1 and 2 combined",
                        "answer_type": "text",
                        "answer_name": "answer_2.5.2c",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '2.5.2d',
                        "answer_label": "% excluded from scope 3 total",
                        "answer_description": "% excluded from scope 3 total",
                        "answer_type": "text",
                        "answer_name": "answer_2.5.2d",
                        "answer_options": [

                        ]
                    },
                ]
            },
            {
                "id": 2.6,
                "field_label": "GHG Inventory data",
                "field_name": "subheading",
                "is_required": false,
            },
            {
                "id": '2.6.1',
                "field_label": "GHG emissions inventory table for the base year and the most recent year.",
                "field_name": "2.6.1",
                "field_description": "For each of the scopes, fill out the table with information from your inventory for the base year in the white section and for the most recent year in the grey section.For targets submitted for validation in 2022,the most recent inventory data submitted must be for 2019 at the earliest.Historically, the SBTi has only allowed two years prior as valid most recent year inventories, however, due to the COVID- 19 pandemic, the SBTi will accept 2019 inventories in 2022.  Emissions (tCO2e): List the amount of emissions in metric tonnes of CO2e (tCO2e) for the relevant year Emissions (tCO2e): List the amount of emissions in metric tonnes of CO2e (tCO2e) for the relevant year.Please enter numbers using the following format using commas for thousand separators and full stops for decimal points i.e., 1,300,526.50.Please do not use these two formats as they can lead to misinterpretations: 1 300 526,50 or 1.300.526,50 For scope 2 emissions, please report emissions under location- or market- based approaches, or under both approaches.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '2.6.1a',
                        "answer_label": "Base year data for Emissions (tCO2e) in Scope 1 (Example input format:  1,300,526.50)",
                        "answer_description": "Base year data for Emissions (tCO2e) in Scope 1 (Example input format:  1,300,526.50)",
                        "answer_type": "text",
                        "answer_name": "answer_2.6.1a",
                        "answer_options": [
                        ],
                    },
                    {
                        "answer_id": '2.6.1b',
                        "answer_label": "Base year data for Emissions (tCO2e) in Scope 2 location based (Example input format:  1,300,526.50) ",
                        "answer_description": "Base year data for Emissions (tCO2e) in Scope 2 location based (Example input format:  1,300,526.50) ",
                        "answer_type": "text",
                        "answer_name": "answer_2.6.1b",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '2.6.1c',
                        "answer_label": "Base year data for Emissions (tCO2e) in Scope 2 market based (Example input format:  1,300,526.50) ",
                        "answer_description": "Base year data for Emissions (tCO2e) in Scope 2 market based (Example input format:  1,300,526.50) ",
                        "answer_type": "text",
                        "answer_name": "answer_2.6.1c",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '2.6.1d',
                        "answer_label": "Most recent year data for Emissions (tCO2e) in Scope 1 (Example input format:  1,300,526.50)",
                        "answer_description": "Most recent year data for Emissions (tCO2e) in Scope 1 (Example input format:  1,300,526.50)",
                        "answer_type": "text",
                        "answer_name": "answer_2.6.1d",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '2.6.1e',
                        "answer_label": "Most recent year data for Emissions (tCO2e) in Scope 2 location based (Example input format:  1,300,526.50)",
                        "answer_description": "Most recent year data for Emissions (tCO2e) in Scope 2 location based (Example input format:  1,300,526.50)",
                        "answer_type": "text",
                        "answer_name": "answer_2.6.1e",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '2.6.1c',
                        "answer_label": "Most recent year data for Emissions (tCO2e) in Scope 2 market based (Example input format:  1,300,526.50) ",
                        "answer_description": "Most recent year data for Emissions (tCO2e) in Scope 2 market based (Example input format:  1,300,526.50) ",
                        "answer_type": "text",
                        "answer_name": "answer_2.6.1c",
                        "answer_options": [

                        ]
                    },
                ]
            },
            {
                "id": '3.1.6',
                "field_label": "Please explain how your proposed scope 1 and 2 emission reduction target will be implemented.",
                "field_name": "3.1.6",
                "field_description": "For each of the scope 1 and 2 emission reduction targets set, briefly describe the main measures planned to reach your proposed scope 1 and 2 targets.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '3.1.6a',
                        "answer_label": "Explanation",
                        "answer_type": "textarea",
                        "answer_name": "answer_3.1.6a",
                        "answer_options": [
                        ]
                    },
                ]
            },
            {
                "id": '3.1.7',
                "field_label": "Please explain how your proposed scope 3 emission reduction target(s) will be implemented.",
                "field_name": "3.1.7",
                "field_description": "Answer this question only if you have set scope 3 emission reduction targets. If not, write “N/A”. For each of the scope 3 emission reduction targets set, briefly describe the main measures planned to reach your proposed scope 3 targets.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '3.1.7a',
                        "answer_label": "Explanation",
                        "answer_type": "textarea",
                        "answer_name": "answer_3.1.7a",
                        "answer_options": [
                        ]
                    },
                ]
            },
            {
                "id": '3.1.8',
                "field_label": " Please expand on the scope 3 emissions covered by supplier/ customer engagement target(s) and a high-level implementation plan of supplier/ customer engagement, if applicable.",
                "field_name": "3.1.8",
                "field_description": "Answer this question only if you have set scope 3 supplier/ customer engagement targets. If not, select “N/A”.The portion of suppliers/ customers that are covered by the target and how much they represent in terms of overall scope 3 emissions should be disclosed.This can be demonstrated by supplying information on the group, percentage, or theme of suppliers that will be covered by the target.A high - level implementation plan of supplier / customer engagement should also be included as separate supporting material(see section 5) or the relevant text can be included within this question.If your company is setting a supplier or customer engagement target on the basis of spend, please provide an estimate of the emissions coverage the suppliers/ customers emissions that are being covered by the target.State whether you will ask your suppliers to set scope 1 and 2 targets or scope 1,2 and 3 targets.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '3.1.8a',
                        "answer_label": "Explanation",
                        "answer_type": "textarea",
                        "answer_name": "answer_3.1.8a",
                        "answer_options": [
                        ]
                    },
                ]
            },
            {
                "id": '3.1.9',
                "field_label": " If you receive less than 50% of your revenue from the activities described in 1.2.11, does your scope 3 target address relevant emissions from the use of sold products? What portion of this category is covered?",
                "field_name": "3.1.9",
                "field_description": "Indicate whether your scope 3 target addresses emissions from category 11 “Use of sold  products”,  and  if  so, which % of the category it covers. For more information on that category, please refer to the Corporate Value Chain (Scope 3) Accounting and Reporting Standard and in particular to Chapter 5 “Identifying Scope 3 Emissions”.Companies that receive less than 50% of their  revenue from these activities must set targets covering 100% of use of sold products emissions using absolute contraction in line with a minimum 1.5°C  scenario (4.2% annual linear reduction), regardless the percentage of revenue they receive from these activities. Customer engagement targets  as  described  are  not eligible for these activities. Fossil fuels distributed must be accounted for in GHG inventory and target boundary, even if they are not sold directly by the company.Oil & Gas companies that receive more than 50% of their revenue from these activities should contact the SBTi to inquire about forthcoming options to validate targets.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '3.1.9a',
                        "answer_label": "Select any one",
                        "answer_type": "radio",
                        "answer_name": "answer_3.1.9a",
                        "answer_options": [
                            { "key": "yes", "value": "Yes" },
                            { "key": "no", "value": "No" },
                            { "key": "n/a", "value": "N/A" },
                        ]
                    },
                    {
                        "answer_id": '3.1.9b',
                        "answer_label": "If yes, indicate use of sold products covered (%):   percentage%",
                        "answer_type": "number",
                        "answer_name": "answer_3.1.9b",
                        "answer_options": [
                        ]
                    },
                ]
            },
            {
                "id": 4,
                "field_label": "Progress reporting",
                "field_name": "heading",
                "is_required": false,
            },
            {
                "id": 4.1,
                "field_label": "Target Maintenance and Progress Reporting",
                "field_name": "subheading",
                "is_required": false,
            },
            {
                "id": '4.1.1',
                "field_label": " How will you report annual company-wide GHG emissions and progress against their targets if they are approved by the SBTi?",
                "field_name": "4.1.1",
                "field_description": "Indicate whether your scope 3 target addresses emissions from category 11 “Use of sold  products”,  and  if  so, which % of the category it covers. For more information on that category, please refer to the Corporate Value Chain (Scope 3) Accounting and Reporting Standard and in particular to Chapter 5 “Identifying Scope 3 Emissions”.Companies that receive less than 50% of their  revenue from these activities must set targets covering 100% of use of sold products emissions using absolute contraction in line with a minimum 1.5°C  scenario (4.2% annual linear reduction), regardless the percentage of revenue they receive from these activities. Customer engagement targets  as  described  are  not eligible for these activities. Fossil fuels distributed must be accounted for in GHG inventory and target boundary, even if they are not sold directly by the company.Oil & Gas companies that receive more than 50% of their revenue from these activities should contact the SBTi to inquire about forthcoming options to validate targetsIndicate where and how frequently your company commits to publicly reporting its company wide GHG emissions inventory and progress against their targets. Examples include annual reports, sustainability reports, the company's website, and/or CDP's annual questionnaire.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '4.1.1a',
                        "answer_label": "Explanation",
                        "answer_type": "textarea",
                        "answer_name": "answer_4.1.1a",
                        "answer_options": [
                        ]
                    },
                ]
            },
            {
                "id": '4.1.2',
                "field_label": "Do you confirm that your company will report on an annual basis in line with the Greenhouse Gas Protocol Accounting framework and report for scope 1, 2 and all scope 3 categories?",
                "field_name": "4.1.2",
                "field_description": "Companies should report in line with the Greenhouse Gas Protocol accounting framework and report for scope 1, 2 and all scope 3 categories as set out in the Protocol.Please indicate whether your company will be reporting in line with the Greenhouse Gas Protocol accounting framework and report for scope 1, 2 and all scope 3 categories as set out in the Protocol. If there are any deviations, please expand in the please explain section.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '4.1.2a',
                        "answer_label": "Select any one",
                        "answer_type": "radio",
                        "answer_name": "answer_4.1.2a",
                        "answer_options": [
                            { "key": "yes", "value": "Yes" },
                            { "key": "no", "value": "No" },
                        ]
                    },
                    {
                        "answer_id": '4.1.2b',
                        "answer_label": "If no, Please explain",
                        "answer_type": "textarea",
                        "answer_name": "answer_4.1.2b",
                        "answer_options": [
                        ]
                    },
                ]
            },
            {
                "id": '4.1.3',
                "field_label": " Do you confirm that your company will publicly report its company-wide GHG emissions inventory and progress against published targets on an annual basis?",
                "field_name": "4.1.3",
                "field_description": "To enable a consistent tracking of emissions over time, companies shall publicly report its company wide GHG emissions inventory and progress against published targets on an annual basis. For detailed guidelines, please review Chapter 5 of the GHG Protocol Corporate Standard Tracking Emissions Over Time and in the section entitled “Reporting and Recalculation” in the SBTi Criteria.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '4.1.3a',
                        "answer_label": "Select any one",
                        "answer_type": "radio",
                        "answer_name": "answer_4.1.3a",
                        "answer_options": [
                            { "key": "yes", "value": "Yes" },
                            { "key": "no", "value": "No" },
                        ]
                    },
                    {
                        "answer_id": '4.1.3b',
                        "answer_label": "If no, Please explain",
                        "answer_type": "textarea",
                        "answer_name": "answer_4.1.3b",
                        "answer_options": [
                        ]
                    },
                ]
            },
            {
                "id": '4.1.4',
                "field_label": "Does your company have a base year emissions recalculation policy that articulates the basis and context for any emission recalculations? If yes, please provide a general description.",
                "field_name": "4.1.4",
                "field_description": "As set out in the Greenhouse Gas Protocol, companies should have a base year emissions recalculation policy in place to retroactively recalculate emissions should certain conditions trigger a need for a recalculation. Please indicate whether your company has a  base year emissions recalculation policy in  place that articulates the basis and context for any emission recalculations. If yes, please provide a general description.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '4.1.4a',
                        "answer_label": "Select any one",
                        "answer_type": "radio",
                        "answer_name": "answer_4.1.4a",
                        "answer_options": [
                            { "key": "yes", "value": "Yes" },
                            { "key": "no", "value": "No" },
                        ]
                    },
                    {
                        "answer_id": '4.1.4b',
                        "answer_label": "If no, Please explain",
                        "answer_type": "textarea",
                        "answer_name": "answer_4.1.4b",
                        "answer_options": [
                        ]
                    },
                ]
            },
            {
                "id": '4.1.5',
                "field_label": "What is your company's threshold for significance?",
                "field_name": "4.1.5",
                "field_description": "SBTi defines the threshold of significance as a cumulative change of five percent or larger in an organization's total base year emissions (tCO2e). For more information, please refer to the Target Validation Protocol.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '4.1.5a',
                        "answer_label": "Select any one",
                        "answer_type": "radio",
                        "answer_name": "answer_4.1.5a",
                        "answer_options": [
                            { "key": "SBTi 5% threshold", "value": "SBTi 5% threshold" },
                            { "key": "Other qualitative threshold", "value": "Other qualitative threshold" },
                            { "key": "Other quantitative threshold", "value": "Other quantitative threshold" }
                        ]
                    },
                ]
            },
            {
                "id": '4.1.6',
                "field_label": "Confirm that your company will follow the GHG Protocol Corporate Standard guidelines for inventory recalculation and the SBTi guidelines for target recalculation as needed to reflect significant changes.",
                "field_name": "4.1.6",
                "field_description": "The SBTi requires companies inventory and accounting practices to be in line with the GHG Protocol Corporate Standard for recalculation purposes. The detailed guidelines can be found in Chapter 5 of the GHG Protocol Corporate Standard and in the section entitled “Reporting and Recalculation in the SBTi Criteria. Please confirm that you will adhere to these guidelines, even after the target is approved.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '4.1.6a',
                        "answer_label": "Select any one",
                        "answer_type": "radio",
                        "answer_name": "answer_4.1.6a",
                        "answer_options": [
                            { "key": "yes", "value": "Yes" },
                            { "key": "no", "value": "No" },
                        ]
                    },
                ]
            },
            {
                "id": '4.1.7',
                "field_label": "Are offsets being counted as progress toward the target(s)?",
                "field_name": "4.1.7",
                "field_description": "If any of the proposed targets uses offsets towards its progress, indicate yes and specify which one(s) with the target ID number.Carbon offsetting refers to the practice of purchasing carbon credits in order to compensate for the GHG emissions generated by the entity purchasing the credits. Please note that the use of offsets must not be counted as reductions toward the progress of companies science-based targets. The SBTi requires that companies set targets based on emission reductions through direct action within their own boundaries or their value chains. Offsets may be useful, however, as an option for companies wishing to finance additional emission reductions beyond the SBT.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '4.1.7a',
                        "answer_label": "Select any one",
                        "answer_type": "radio",
                        "answer_name": "answer_4.1.7a",
                        "answer_options": [
                            { "key": "yes", "value": "Yes" },
                            { "key": "no", "value": "No" },
                        ]
                    },
                ]
            },
            {
                "id": '4.1.8',
                "field_label": "Do any of the targets cover avoided emissions?",
                "field_name": "4.1.8",
                "field_description": "Indicate whether your scope 3 target(s) include avoided emissions. If the answer varies among different scope 3 targets, specify for each one using the target IDs.Avoided emissions are emission reductions that occur outside of a product's life cycle or value chain, but as a result of the use of that product. Examples of products (goods and services) that avoid emissions include low- temperature detergents, fuel-saving tires, energy-efficient ball-bearings, and teleconferencing services. Other terms used to describe avoided emissions include climate positive, net-positive accounting, and scope 4. Avoided emissions fall under a separate accounting system from corporate inventories and do not count toward science-based targets.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '4.1.8a',
                        "answer_label": "Select any one",
                        "answer_type": "radio",
                        "answer_name": "answer_4.1.8a",
                        "answer_options": [
                            { "key": "yes", "value": "Yes" },
                            { "key": "no", "value": "No" },
                        ]
                    },
                ]
            },
            {
                "id": '4.1.9',
                "field_label": "Do you confirm that you will review, and if necessary, recalculate and revalidate your targets to ensure consistency with most recent climate science and best practices at a minimum every 5 years? ( For companies with targets approved in 2020 or earlier, the latest year targets must be revalidated is 2025. The most recently applicable criteria must be followed for resubmission. )",
                "field_name": "4.1.9",
                "field_description": "As per Criterion - “Mandatory target recalculation”, companies must commit to reassessing, and if necessary, recalculating and revalidating their targets, at a minimum every 5 years. The latest year companies with approved targets must revalidate targets is 2025. The most recent applicable criteria must be followed at the time of revalidation. Please refer to Recommendation - “Triggered target recalculation” for examples changes that trigger recalculation.  ",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '4.1.9a',
                        "answer_label": "Select any one",
                        "answer_type": "radio",
                        "answer_name": "answer_4.1.9a",
                        "answer_options": [
                            { "key": "yes", "value": "Yes" },
                            { "key": "no", "value": "No" },
                        ]
                    },
                ]
            },
            {
                "id": 5,
                "field_label": "Supporting Documentation",
                "field_name": "heading",
                "is_required": false,
            },
            {
                "id": 5.1,
                "field_label": "SUPPORTING DOCUMENTATION",
                "field_name": "subheading",
                "is_required": false,
            },
            {
                "id": '5.1.1',
                "field_label": "Provide a list and briefly describe any background information submitted with this form",
                "field_name": "5.1.1",
                "field_description": "List any documentation submitted with this form. Companies may submit supporting documentation if it is directly related to the information requested. Indicate the specific page numbers, figures or text that is being referred to in accompanying documents within the submission form.If relevant, please include: Copies of tool(s) used to develop your targets and CDP climate change questionnaire responses for the base year and the most recent response.Examples of other supporting documentation to include if deemed relevant: calculations used to develop the targets, sustainability plans, etc.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '5.1.1a',
                        "answer_label": "Explanation",
                        "answer_type": "textarea",
                        "answer_name": "answer_5.1.1a",
                        "answer_options": [

                        ]
                    },
                ]
            },
            {
                "id": '5.1.2',
                "field_label": "Are there any discrepancies between supporting documents and/or other publicly available data?",
                "field_name": "5.1.2",
                "field_description": "During the target validation process, the SBTi team may cross-check information between submitted documentation and other information publicly available. If there are discrepancies between different supporting documents submitted with this form and/or other publicly available data (for example, if emissions data reported in this form differs from the data disclosed in the CDP climate change questionnaire or in a sustainability report), state which discrepancies exist and explain it in this section.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '5.1.2a',
                        "answer_label": "Select any one",
                        "answer_type": "radio",
                        "answer_name": "answer_5.1.2a",
                        "answer_options": [
                            { "key": "yes", "value": "Yes" },
                            { "key": "no", "value": "No" },
                        ]
                    },
                    {
                        "answer_id": '5.1.2b',
                        "answer_label": "If no, Please explain",
                        "answer_type": "textarea",
                        "answer_name": "answer_5.1.2b",
                        "answer_options": [
                        ]
                    },
                ]
            },
            {
                "id": '5.1.3',
                "field_label": "OTHER INFORMATION/COMMENTS",
                "field_name": "5.1.3",
                "field_description": "Please provide any additional information you consider pertinent to your target validation.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '5.1.3a',
                        "answer_label": "Information/comments",
                        "answer_type": "textarea",
                        "answer_name": "answer_5.1.3a",
                        "answer_options": [

                        ]
                    },
                ]
            },
            {
                "id": 6,
                "field_label": "Contractual and Billing Information",
                "field_name": "heading",
                "is_required": false,
            },
            {
                "id": 6.1,
                "field_label": "CONTRACTUAL AND BILLING INFORMATION",
                "field_name": "subheading",
                "is_required": false,
            },
            {
                "id": '6.1.1',
                "field_label": "Please indicate the company's legal name that we should use for the Terms & Conditions as well as for issuing the invoice",
                "field_name": "6.1.1",
                "field_description": "Please indicate the legal name of the company it needs to be displayed within the Terms & Conditions. If the name for billing purposes is different, please state so here and specify which one is for the T&C's and which one for the invoice.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '6.1.1a',
                        "answer_label": "Client's name",
                        "answer_type": "text",
                        "answer_name": "answer_6.1.1a",
                        "answer_options": [

                        ]
                    },
                ]
            },
            {
                "id": '6.1.2',
                "field_label": "Please indicate the company's address that we should use for the Terms & Conditions. ",
                "field_name": "6.1.2",
                "field_description": "Please indicate the address of the company that we should input within the Terms & Conditions.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '6.1.2a',
                        "answer_label": "Client's address ",
                        "answer_type": "text",
                        "answer_name": "answer_6.1.2a",
                        "answer_options": [

                        ]
                    },
                ]
            },
            {
                "id": '6.1.3',
                "field_label": "Please indicate the company's VAT number for invoicing purposes. ",
                "field_name": "6.1.3",
                "field_description": "Please indicate the company's VAT number for invoicing purposes. If your company does not have a VAT number, please write N/A.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '6.1.3a',
                        "answer_label": "Client's VAT number ",
                        "answer_type": "text",
                        "answer_name": "answer_6.1.3a",
                        "answer_options": [

                        ]
                    },
                ]
            },
            {
                "id": '6.1.4',
                "field_label": "Please indicate the company's representative for contractual purposes. ",
                "field_name": "6.1.4",
                "field_description": "Please fill in with the information of the person who will be the contact of the company for contractual purposes.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '6.1.4a',
                        "answer_label": "Name",
                        "answer_type": "text",
                        "answer_name": "answer_6.1.4a",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '6.1.4b',
                        "answer_label": "Title",
                        "answer_type": "text",
                        "answer_name": "answer_6.1.4b",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '6.1.4c',
                        "answer_label": "E-mail",
                        "answer_type": "text",
                        "answer_name": "answer_6.1.4c",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '6.1.4d',
                        "answer_label": "Telephone",
                        "answer_type": "text",
                        "answer_name": "answer_6.1.4d",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '6.1.4e',
                        "answer_label": "Postal address",
                        "answer_type": "text",
                        "answer_name": "answer_6.1.4e",
                        "answer_options": [

                        ]
                    },
                ]
            },
            {
                "id": '6.1.5',
                "field_label": "Name and title of the person who will be signing the Terms & Conditions (if different from Client's representative)",
                "field_name": "6.1.5",
                "field_description": "If the person who will be signing the Terms & Conditions is different from the Client's representative, please indicate it here.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '6.1.5a',
                        "answer_label": "Name",
                        "answer_type": "text",
                        "answer_name": "answer_6.1.5a",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '6.1.5b',
                        "answer_label": "Title",
                        "answer_type": "text",
                        "answer_name": "answer_6.1.5b",
                        "answer_options": [

                        ]
                    },
                ]
            },
            {
                "id": '6.1.6',
                "field_label": "To whom should we address the invoice?",
                "field_name": "6.1.6",
                "field_description": "Please indicate the complete name and email of the person to whom we should address the invoice.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '6.1.6a',
                        "answer_label": "Name",
                        "answer_type": "text",
                        "answer_name": "answer_6.1.6a",
                        "answer_options": [

                        ]
                    },
                    {
                        "answer_id": '6.1.6b',
                        "answer_label": "E-mail",
                        "answer_type": "text",
                        "answer_name": "answer_6.1.6b",
                        "answer_options": [

                        ]
                    },
                ]
            },
            {
                "id": '6.1.7',
                "field_label": "Which address should we use in the invoice? ",
                "field_name": "6.1.7",
                "field_description": "Please indicate the address that should appear within the invoice. Note that this is just for information within the invoice. The invoice will be a PDF document sent via email. If it is absolutely necessary for your company to have the invoice sent by post, please indicate the postal address here. If this is the case, please also indicate if you need to have the invoice signed and stamped.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '6.1.7a',
                        "answer_label": "Please note that this is just for information on the invoice. The invoice will be a PDF document sent via email.",
                        "answer_type": "textarea",
                        "answer_name": "answer_6.1.7a",
                        "answer_options": [

                        ]
                    },
                ]
            },
            {
                "id": '6.1.8',
                "field_label": "Will you be raising a PO number or any other special information for us to add to the invoice?",
                "field_name": "6.1.8",
                "field_description": "If you are raising a PO, please let us know here which documents you will need from either CDP North America (for companies headquartered in the USA and Canada) or CDP Operations Limited (for companies in the rest of the world). If you will need us to fill a vendor form, please send it with your submission form.",
                "is_required": false,
                "answers": [
                    {
                        "answer_id": '6.1.8a',
                        "answer_label": "If you're raising a PO, please let us know which documents you need from us.",
                        "answer_type": "textarea",
                        "answer_name": "answer_6.1.8a",
                        "answer_options": [

                        ]
                    },
                ]
            },
        ]
    };
    // const [formState, setFormState] = useState(formFeilds);
    const userdetails = JSON.parse(localStorage.getItem('userdetails'))
    const [sbtiReportData, setSbtiReportData] = useState([])
    const [isSaving, setIsSaving] = useState(false)
    const navigate = useNavigate();
    const year = new Date().getFullYear(); // For the current year, or replace with your dynamic value
    const { data: companyData, isLoading: isCompanyLoading } = useFetch(`sbti?company_id=${userdetails.company_id}&year=${year}`);
    
    

    useEffect(() => {
        if (!isCompanyLoading) {
            const dataToSet = !Array.isArray(companyData.data) && Object.keys(companyData.data).length > 0 ?
             companyData.data : formFeilds;
            setSbtiReportData(dataToSet);
        }
    }, [isCompanyLoading, companyData]);


    if (isCompanyLoading) {
        return (
            <>
                <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
                    <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                        <h1 className="h2"> <i className="fa-solid fa-spinner fa-spin"></i></h1>
                    </div>
                </main>
            </>
        )
    }


    const handleInputChange = (label, ansid, value) => {
        setSbtiReportData(prevSbtiReportData => {
            const updatedFormValues = prevSbtiReportData.fields.map(formData => {
                if (formData.id === label.id) {
                    const updatedAnswers = formData.answers.map(answer => {
                        if (answer.answer_id === ansid.answer_id) {
                            if (answer.answer_type === 'checkbox') {
                                const valuesArray = answer.answer_value ? answer.answer_value.split(',') : [];
                                const valueIndex = valuesArray.indexOf(value);

                                if (valueIndex === -1) {
                                    // If checkbox is checked and value is not already present, add it
                                    valuesArray.push(value);
                                } else {
                                    // If checkbox is unchecked and value is already present, remove it
                                    valuesArray.splice(valueIndex, 1);
                                }

                                const updatedValue = valuesArray.join(',');
                                return {
                                    ...answer,
                                    answer_value: updatedValue,
                                };  
                            } else {
                                return {
                                    ...answer,
                                    answer_value: value || '',
                                };
                            }
                        }
                        return answer;
                    });
                    return {
                        ...formData,
                        answers: updatedAnswers,
                    };
                }
                return formData;
            });

            return {
                ...prevSbtiReportData,
                fields: updatedFormValues,
            };
        });
    };

    const saveData = (dataToSave) => {
        setIsSaving(true);
        create(dataToSave, 'sbti')
            .then(res => {
                console.log(res);
            })
            .finally(() => {
                setIsSaving(false);
            });
    };

    const handleSubmit = event => {
        event.preventDefault();
        const d = new Date();
        let year = d.getFullYear();
        const submitData = {
            company_id: userdetails.company_id,
            year: year,
            data: sbtiReportData,
        };
        setIsSaving(true);
        saveData(submitData);
    };

    const exportSbtiReport = () => {
        exportToExcel(EXPORT_SBTIREPORT_API, 'sbtiReport')
    };

    if (isSaving) {
        return (
            <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                    <h1 className="h2"> <i className="fa-solid fa-spinner fa-spin"></i></h1>
                </div>
            </main>
        );
    }


    return (
        <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                <h1 className="h2">SBTI Q & A</h1>
                <div className="buttons-right">
                       <button className="btn btn-primary btn-add"  onClick={() => saveData({
                              company_id: userdetails.company_id,
                              year: year,
                              data: sbtiReportData,
                        })} >
                            Save 
                        </button>
                    
                    <button className='btn btn-primary btn-add' onClick={exportSbtiReport} > <i class="fa-solid fa-file-import"></i> Export Report </button>
            
                    </div>
            </div>
            <form onSubmit={handleSubmit}>
                {sbtiReportData.fields && sbtiReportData.fields.length > 0 ? sbtiReportData.fields.map((field, idx) => (

                    <div className="mt-3" key={field.id}>
                        {
                            field.field_name == "heading" ? <h1 className='heading'>{field.field_label}</h1> : field.field_name == "subheading" ? <h5 className='heading'>{field.field_label}</h5> :
                                <div className='griform'>
                                    <br></br>
                                    {field.field_name !== "heading" &&
                                        <label htmlFor={field.field_name}><b>{field.field_name}:</b> {field.field_label}</label>}
                                    <span className="info-icon-container">
                                        <i className="fa fa-info-circle info-icon" aria-hidden="true"></i>
                                        <div className="info-message">{field.field_description}</div>
                                    </span>
                                    {field.answers && field.answers.length > 0 ? (field.answers.map((answer, indx) => {
                                        switch (answer.answer_type) {
                                            case 'dropdown':
                                                return (
                                                    <div>
                                                        <br></br>
                                                        <label><b>{answer.answer_label} </b></label>
                                                        <br></br>

                                                        <select
                                                            className="form-select"
                                                            key={answer.answer_id}
                                                            name={`${field.field_name}_${answer.answer_name}`}
                                                            value={answer.answer_value}
                                                            onChange={(e) => handleInputChange(field, answer, e.target.value)}
                                                        >
                                                            <option value="">Select an option</option>
                                                            {answer.answer_options.map((option) => (
                                                                <option key={option.key} value={option.key}>
                                                                    {option.value}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                );
                                            case 'radio':
                                                return (

                                                    <div key={answer.answer_id}>
                                                        <br></br>
                                                        <label><b>{answer.answer_label} </b></label>
                                                        {answer.answer_options.map((option) => (

                                                            <div className="form-radio" key={option.key}>
                                                                <input
                                                                    type="radio"
                                                                    name={`${field.field_name}_${answer.answer_name}`}
                                                                    value={option.key}
                                                                    checked={answer.answer_value === option.key}
                                                                    onChange={(e) => handleInputChange(field, answer, e.target.value)}
                                                                />
                                                                <label>{option.value}</label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                );
                                            case 'checkbox':
                                                return (

                                                    <div key={answer.answer_id}>
                                                        <br></br>
                                                        <label><b>{answer.answer_label} </b></label>
                                                        {answer.answer_options.map((option) => (
                                                            <div className="form-radio" key={option.key}>
                                                                <input
                                                                    type="checkbox"
                                                                    name={`${field.field_name}_${answer.answer_name}`}
                                                                    value={option.key}
                                                                    checked={answer.answer_value}
                                                                    onChange={(e) => handleInputChange(field, answer, e.target.value)}
                                                                />
                                                                <label>{option.value}</label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                );
                                            case 'textarea':
                                                return (
                                                    <div>
                                                        <br></br>
                                                        <label><b>{answer.answer_label && `${answer.answer_label}`}</b></label>
                                                        <br></br>
                                                        <textarea
                                                            key={answer.answer_id}
                                                            type="text"
                                                            maxLength="5000"
                                                            name={`${field.field_name}_${answer.answer_name}`}
                                                            value={answer.answer_value}
                                                            onChange={(e) => handleInputChange(field, answer, e.target.value)}
                                                            rows="3" cols="50"
                                                        />
                                                    </div>
                                                );
                                            case 'text':
                                                return (
                                                    <div>
                                                        <br></br>
                                                        <label><b>{answer.answer_label} </b></label>
                                                        <br></br>
                                                        <input
                                                            key={answer.answer_id}
                                                            type="text"
                                                            name={`${field.field_name}_${answer.answer_name}`}
                                                            value={answer.answer_value}
                                                            onChange={(e) => handleInputChange(field, answer, e.target.value)}
                                                        />
                                                    </div>
                                                );
                                            case 'number':
                                                return (
                                                    <div>
                                                        <br></br>
                                                        <label><b>{answer.answer_label} </b></label>
                                                        <br></br>
                                                        <input
                                                            key={answer.answer_id}
                                                            type="number"
                                                            step="0.001"
                                                            min="0"
                                                            max="999999999999"
                                                            name={`${field.field_name}_${answer.answer_name}`}
                                                            value={answer.answer_value}
                                                            onChange={(e) => handleInputChange(field, answer, e.target.value)}
                                                        />
                                                    </div>
                                                );
                                            case 'date':
                                                return (
                                                    <div>
                                                        <br></br>
                                                        <label><b>{answer.answer_label} </b> </label>
                                                        <input
                                                            key={answer.answer_id}
                                                            type="date"
                                                            name={`${field.field_name}_${answer.answer_name}`}
                                                            value={answer.answer_value}
                                                            onChange={(e) => handleInputChange(field, answer, e.target.value)}
                                                        />
                                                    </div>
                                                );
                                            case 'file':
                                                return (
                                                    <div>
                                                        <br></br>
                                                        <label><b>{answer.answer_label} </b> </label>
                                                        <input
                                                            key={answer.answer_id}
                                                            type="file"
                                                            id="myfile"
                                                            name={`${field.field_name}_${answer.answer_name}`}
                                                            onChange={(e) => handleInputChange(field, answer, e.target.value)}
                                                        />
                                                    </div>
                                                )
                                            default:
                                                return null;
                                        }
                                    })) :
                                        (
                                            ""
                                        )}
                                </div>}
                    </div>
                )) : (
                    <span>No sbti reports data available.</span>
                )}
                <div className="mt-3 mb-3">
                    <button className="btn btn-primary btn-add" type="submit">Submit</button>
                </div>
            </form>
        </main>
    );
};

export default Sbti;


